import api from './Api';
import { getMonthAndYear } from '@/utils/dateHelper';
let BASE_URL = "earnings/";

// Helper function to format date to yyyy-mm-dd
function formatToLocalDateString(dateInput) {
    const date = new Date(dateInput);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export default {
    getAdvertiserEarningsBySite: (from, to, siteIds) => {
        // Ensure the dates are in the correct format
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        // Convert siteIds array to a comma-separated string
        const siteIdParam = Array.isArray(siteIds) ? siteIds.join(',') : siteIds;
        return api.get(`${BASE_URL}`, {
            params: {
                from: formattedFrom,
                to: formattedTo,
                siteIds: siteIdParam
            }
        });
    },
    getByAdvertiser: (from, to)=> {
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        return api.get(`${BASE_URL}advertiser`, {
            params: {
                from: formattedFrom,
                to: formattedTo
            }
        });
    },
    getByPublisher: (from, to)=> {
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        return api.get(`${BASE_URL}publishers`, {
            params: {
                from: formattedFrom,
                to: formattedTo
            }
        }); 
    },
    getAdvertiserEarningsByPublisher: (from, to, userId)=> {
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        return api.get(`${BASE_URL}advertisers-by-publisher`, {
            params: {
                from: formattedFrom,
                to: formattedTo,
                userId
            }
        });
    },
    getAdvertiserEarningsByPublishers: (from, to, advertiserId)=> {
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        return api.get(`${BASE_URL}advertiser-by-publishers`, {
            params: {
                from: formattedFrom,
                to: formattedTo,
                advertiserId
            }
        });
    },
    getAdvertiserEarningsByPublishersUsingAdvertiserName: (from, to, name)=> {
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        return api.get(`${BASE_URL}advertiser-by-publishers/${name}`, {
            params: {
                from: formattedFrom,
                to: formattedTo
            }
        });
    },
    getBySite: (from, to)=> {
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        return api.get(`${BASE_URL}site`, {
            params: {
                from: formattedFrom,
                to: formattedTo
            }
        });
    },
    getUserLastMonthRevenue: ()=> {
        return api.get(`${BASE_URL}user-last-month`);
    },
    getUserTotalNetRevenue: (userId = null) => {
        const params = userId ? { userId } : {};
        return api.get(`${BASE_URL}user-total-revenue`, { params });
    },
    getUserDailyStats: (userId, from, to) => {
        const formattedFrom = formatToLocalDateString(from);
        const formattedTo = formatToLocalDateString(to);
        return api.get(`${BASE_URL}user-daily-stats`, {
            params: {
                userId,
                from: formattedFrom,
                to: formattedTo
            }
        });
    },
    getAdvertiserDailyStats: (advertiserId, date) => {
        const { month, year } = getMonthAndYear(date);
        return api.get(`${BASE_URL}advertiser-daily`, {
            params: {
                advertiserId,
                month,
                year
            }
        });
    },
    getAdvertiserEarningsForCsvExport: (date) => {
        return api.get(`${BASE_URL}csv-advertiser`, {
            params: {
                date
            }
        });
    },
    // `date` is the day the adjustment is for, as a bare 'YYYY-MM-DD'. The deal
    // rates in force depend on it, so the dialog refetches whenever it changes.
    getBySiteBrandLink: (siteBrandLinkId, date) => {
        return api.get(`${BASE_URL}site-brand-link`, {
            params: date ? { siteBrandLinkId, date } : { siteBrandLinkId }
        });
    },
    saveAdjustment: (siteBrandLinkId, selectedAdjustmentType, selectedDate, cpaAdjustment, publisherRevenue, ourRevenue, clicks, ftds, regs) => {
        return api.post(`${BASE_URL}save-adjustment`, {
            siteBrandLinkId,
            selectedAdjustmentType,
            selectedDate,
            cpaAdjustment,
            publisherRevenue,
            ourRevenue,
            clicks,
            ftds,
            regs
        });
    }
};
